import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class BaseService {
    constructor() { }

    // public BaseHost = 'http://localhost:54277';
    public BaseHost = 'https://hotrodoan.vn';

    public BaseURI = this.BaseHost + '/api';
}